import { createFileRoute } from '@tanstack/react-router';
import { SellEarnings } from '../../pages/sell/SellEarnings';

export const Route = createFileRoute('/dashboard/sell/earnings')({ component: SellEarnings });
